import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

const init = async () => {
  document.querySelectorAll('[data-splide-carousel]').forEach((carousel) => {
    let s
    if ((carousel as HTMLElement).dataset.splideAutoScroll) {
      s = new Splide(carousel as HTMLElement).mount({ AutoScroll })
    } else {
      s = new Splide(carousel as HTMLElement).mount()
    }
    const elsToShowHide = carousel
      .closest('section')
      ?.querySelectorAll(
        '[splide-show-on-only-on-first-slide]',
      ) as NodeListOf<HTMLElement>
    if (elsToShowHide) {
      s.on('move', (index) => {
        if (index === 0) {
          elsToShowHide.forEach((el) => {
            el.style.visibility = 'visible'
          })
        } else {
          elsToShowHide.forEach((el) => {
            el.style.visibility = 'hidden'
          })
        }
      })
    }
  })
}

export default function () {
  init()
  document.addEventListener('shopify:section:load', init)
}
